import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IziviaAppLayoutService {
    private _appLayout: BehaviorSubject<AppLayout> = new BehaviorSubject(AppLayout.FOREGROUND);

    currentAppLayout(): AppLayout {
        return this._appLayout.value;
    }
    isForeground(): boolean {
        return this._appLayout.value === AppLayout.FOREGROUND;
    }

    setForground() {
        this._appLayout.next(AppLayout.FOREGROUND);
    }
    setBackground() {
        this._appLayout.next(AppLayout.BACKGROUND);
    }

}


export enum AppLayout {
    'BACKGROUND' = 'BACKGROUND',
    'FOREGROUND' = 'FOREGROUND'
}
